module.exports = __webpack_public_path__ + "img/7_uk.38815408.svg";